import { Grid, Typography } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { formatNumber, formatDate } from "../../Utils/utils";
import { DataTabs } from "../LabTabs";
import { transactionType } from "../../Utils/transactionType";
import { Alert } from "@mui/material";
import { useState } from "react";
import { isTestEnv } from "../../globals";
import { useUser } from "../../contexts/UserContext";

export const OpenInvoices = ({ OpenInvoices, OpenInvoicesPerBranch, statusError }) => {
  const [expandedPanel, setExpandedPanel] = useState(false);
  const { user } = useUser();

  const handleChange = (event, isExpanded) => {
    setExpandedPanel(isExpanded);
  };
  isTestEnv && console.log("OpenInvoices", OpenInvoices);

  const dataGridColumns = [
    { field: "IVNUM", headerName: "אסמכתא", cellClassName: "first-column" },
    { field: "FNCNUM", headerName: "מספר תנועת יומן" },
    {
      field: "SUM1",
      headerName: "סכום",
      renderCell: (params) => formatNumber(params.value),
    },
    { field: "DETAILS", headerName: "פרטים" },
    { field: "FNCPATNAME", headerName: "סוג תנועה" },
    {
      field: "FNCDATE",
      headerName: "תאריך ערך",
      type: 'date',
    },
    {
      field: "BALDATE",
      headerName: "תאריך למאזן",
      type: 'date',
    },
    { field: "Y_16227_5_ESHB", headerName: "מספר חברה" },
  ];
  
  const OInvoices = OpenInvoices?.map((row, index) => ({
    ...row,
    id: index,
    FNCPATNAME: transactionType[row["FNCPATNAME"]],
    FNCDATE: new Date(row["FNCDATE"]),
    BALDATE: new Date(row["BALDATE"])
  }));
  
  const OInvoicesPerBranch = OpenInvoicesPerBranch?.map((row, index) => ({
    ...row,
    id: index,
    FNCPATNAME: transactionType[row["FNCPATNAME"]],
    FNCDATE: new Date(row["FNCDATE"]),
    BALDATE: new Date(row["BALDATE"])
  }));

  return (
    <Accordion expanded={expandedPanel} onChange={handleChange} disabled={OpenInvoices === null}>
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon />}
        aria-controls="panel-content"
        id="panel-header"
        style={{
          backgroundColor: expandedPanel ? "#f0f0f0" : "inherit",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "5px",
            borderRadius: "5px",
          }}
        >
          <span
            style={{
              fontWeight: "bold",
              fontSize: "1.2rem",
            }}
          >
            חשבוניות פתוחות
          </span>
        </div>
      </AccordionSummary>
      {statusError ? (
        <Alert severity="error">אירעה תקלה. נא נסו שנית מאוחר יותר</Alert>
      ) : (OpenInvoices?.length === 0 || (user?.userBranchesList?.length > 0 && OInvoicesPerBranch?.length === 0)) ? (
        <Alert severity="info">אין חשבוניות פתוחות ללקוח</Alert>
      ) : (
        <div>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography>
                  {dataGridColumns !== "undefined" && (
                    <DataTabs
                      data={OInvoicesPerBranch}
                      data2={OInvoices}
                      columns={dataGridColumns}
                      TabKey={{ value: "BRANCHNAME", label: "סניף" }}
                      hideAllTab={user?.userBranchesList?.length > 0}  

                    />
                  )}
                </Typography>
              </Grid>
            </Grid>
          </AccordionDetails>
        </div>
      )}
    </Accordion>
  );
};